import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { BootstrapService } from "../modules/bootstrap/bootstrap.service";
import { absoluteUrl } from "../support/navigation";
import { sntNavigate } from "src/app/support/router";

@Injectable()
export class DefaultRouteByRoleGuard {
  private readonly router = inject(Router);
  private readonly bootstrapService = inject(BootstrapService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentRoles = this.bootstrapService
      .getCurrentMember()
      ?.roles?.map((x) => x.type);

    switch (true) {
      case currentRoles?.includes("reporter") && currentRoles.length === 1: {
        sntNavigate(this.router, [absoluteUrl("/reporting")]);
        return false;
      }
      default: {
        sntNavigate(this.router, [absoluteUrl("/studies")]);
        return true;
      }
    }
  }
}
